import React from 'react';
import { useTranslator } from 'tradera-lang/translate';
import ShieldIcon from '@tradera/blueprint/theme/icons2/shield.svg?jsx';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import { InfoTooltip } from 'tradera-apps/syi/script/app_react/components/info-tooltip';

const BuyerProtectionInfo = ({ className }) => {
    const { t } = useTranslator();

    return (
        <div
            className={`position-relative ${className}`}
            style={{ maxWidth: '30rem' }}>
            <span className="text-gray-600">
                {t('payment_method_info_hasBuyerProtection')}
            </span>
            <InfoTooltip
                containerClassName="ml-1"
                customIcon={<ShieldIcon className="icon icon-default" />}>
                <div className="d-flex">
                    <InfoIcon
                        className="icon icon-xs mr-2 flex-shrink-0"
                        style={{
                            height: '21px'
                        }}
                    />
                    <div // eslint-disable-next-line react/no-danger
                        dangerouslySetInnerHTML={{
                            __html: t('payment_method_info_buyerProtection')
                        }}
                    />
                </div>
            </InfoTooltip>
        </div>
    );
};

export default BuyerProtectionInfo;
